import { EmergencyContactSection } from "~/features/quote/components/shipment-details/components/additional-details-section/emergency-contact-section.tsx";

import tenderLtlStyles from "../../index.module.css";

type TenderHazardousMaterialsDetailsProps = {
	hasFieldError: (field: string) => boolean;
	onClearFieldError: (field: string) => void;
	isRequired?: boolean;
};

export const TenderHazardousMaterialsDetails = ({
	hasFieldError,
	onClearFieldError,
	isRequired = true,
}: TenderHazardousMaterialsDetailsProps) => {
	return (
		<div className={tenderLtlStyles.tenderLtlCard}>
			<h4>Hazardous Materials Details</h4>
			<EmergencyContactSection
				hasFieldError={hasFieldError}
				isRequired={isRequired}
				onClearFieldError={onClearFieldError}
			/>
		</div>
	);
};
